import { pagesSubTitleCat, pagesTitleCat } from '../../data/MochaData';
const PagesTitle = ({ index = 0 }: IPropsPages) => {
    if (index == 4) return <></>
    return (
        <>
            <div className="lbl-paso-t1 mt10">
                <span className="">{pagesTitleCat[index]}</span>
            </div>
            <div className="mt-10">
                <span className="lbl-paso-t2">(*) Espacios requeridos</span>
            </div>
            <div className="mt-5 mb-30">
                <span className="lbl-paso-t3">{pagesSubTitleCat[index]} </span>
            </div>
        </>
    );
}

export { PagesTitle };